//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TooltipColumn',
  props: {
    // 列名
    label: {
      type: String,
      default: '',
    },
    // 属性名
    name: {
      type: String,
      default: '',
    },
    // 字数限制
    limit: {
      type: Number,
      default: 20,
    },
  },
  methods: {
    showText(text) {
      if (this.limit) {
        return text.length > this.limit ? text.slice(0, this.limit) : text;
      }
      return text;
    },
  },
};
